//import { View } from 'react-native'
import React from 'react'
//TODO
import intl from 'react-intl-universal';
import {CCActivityIndicator, strings, Constants} from './../cc-imports'
import DataActionTypes from "../data/actions/types/DataActionTypes";

const CCUIUtils = {

    getLocaleStr:(value)=>{
        let locale = intl.currentLocale;
        if(value[locale]===null || value[locale]===undefined || value[locale].length===0){
            return value['en'];
        }
        else {
            return value[locale];
        }
    },

    getEmptyListItem : (reqStatus, emptyListTitle) =>{
        if(reqStatus==Constants.reqStatus.COM || reqStatus==Constants.reqStatus.FAI){
            return (
                <div style={{height: 20, marginTop: 30, alignItems: 'center', justifyContent: 'center', textAlign: 'center'}}>
                    <h3 style={{fontSize: '1vw'}}>{emptyListTitle ? emptyListTitle : strings('end_of_results')}</h3>
                </div>
            );
        }
        else {
            return(<CCActivityIndicator size={'large'}/>)
        }
    },

        //updated
        getListFooter : (reqStatus, type, data) => {
            if (data && data.length == 0) {
                return <div/>
            }

            if( ((reqStatus==Constants.reqStatus.COM||reqStatus==Constants.reqStatus.SUC) && type!==DataActionTypes.GET && type!==undefined)||(reqStatus===Constants.reqStatus.FAI && type===DataActionTypes.PAGINATE)){
                return (
                    <div style={{height: 20, marginBottom: 10, alignItems: 'center', justifyContent: 'center'}}>
                        <h2 title={strings('end_of_results')}/>
                    </div>
                )
            }
            else {
                return (
                    <div style={{height: 20, marginBottom: 10}}>
                        <CCActivityIndicator size={"s"}/>
                    </div>
                )
            }

        },


    getFlatListFooter : (loading, completed, data) => {
            if (data && data.length === 0) {
                return <div/>
            }
            if (loading) {
                return (
                    <div style={{height: 20, marginBottom: 10}}>
                        <CCActivityIndicator size={"s"}/>
                    </div>
                )
            }
            else if (completed) {
                return (
                    <div style={{height: 20, marginBottom: 10, alignItems: 'center', justifyContent: 'center'}}>
                        <h2 title={strings('end_of_results')}/>
                    </div>
                )
            }
        }
};

export  {CCUIUtils};



// WEBPACK FOOTER //
// ./src/app/lib/CCUIUtils.js